import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { Box, Button, makeStyles } from '@popmenu/common-ui';

type DishFeedTab = 'feed' | 'forYou';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  tab: {
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 20,
    fontWeight: 600,
    minHeight: 40,
    textTransform: 'none',
  },
  tabSelected: {
    '&:hover': {
      backgroundColor: theme.palette.text.primary,
    },
    backgroundColor: theme.palette.text.primary,
    borderColor: theme.palette.text.primary,
    color: theme.palette.common.white,
  },
}));

type DishFeedTabsProps = {
  feedPath: string
  forYouPath: string
  selected: DishFeedTab
}

// Switches a place between its trending dish feed and the dishes ranked for the signed-in diner
export const DishFeedTabs = ({ feedPath, forYouPath, selected }: DishFeedTabsProps) => {
  const classes = useStyles();
  const intl = useIntl();
  const tabs: { label: string, path: string, value: DishFeedTab }[] = [
    { label: intl.formatMessage({ defaultMessage: 'Dish Feed' }), path: feedPath, value: 'feed' },
    { label: intl.formatMessage({ defaultMessage: 'For You' }), path: forYouPath, value: 'forYou' },
  ];

  return (
    <Box aria-label={intl.formatMessage({ defaultMessage: 'Dish views' })} className={classes.container} component="nav">
      {tabs.map(tab => (
        <Button
          key={tab.value}
          aria-current={selected === tab.value ? 'page' : undefined}
          className={`${classes.tab} ${selected === tab.value ? classes.tabSelected : ''}`}
          component={Link}
          role="link"
          to={tab.path}
        >
          {tab.label}
        </Button>
      ))}
    </Box>
  );
};
